import RequestToken from "./RequestToken";
import ScopeTokenValues from "./ScopeTokenValues";

const logSvc = new WeakMap();

class ScopeToken extends RequestToken {
    constructor($log, tokenValue) {
        super("scopeToken");

        if (!((tokenValue === ScopeTokenValues.BeginScope) ||
            (tokenValue === ScopeTokenValues.EndScope) ||
            (tokenValue === ScopeTokenValues.ClosedScope))) {

            throw new TypeError("Invalid Scope Token Value");
        }

        this._tokenParams = {
            scopeType: tokenValue
        };

        if ($log != null) {
            logSvc.set(this, $log);
        }
        else {
            throw new Error("Scope Token: Missing or invalid log service dependency");
        }

    }

    /* override */
    toString() {
        const scopeDesc = ScopeTokenValues.Translate(this._tokenParams.scopeType);
        return "ScopeToken (" + scopeDesc + ")";
    }

    /* override */
    toSearchRequest(childRequests) {
        if (!((angular.isArray(childRequests)) && (childRequests.length === 1))) {
            throw new TypeError("Building Search Request From Scope Token Requires Exactly 1 Child");
        }

        switch (this._tokenParams.scopeType) {
            case ScopeTokenValues.BeginScope:
                logSvc.get(this).error("Invalid Search Request: Unbalanced Parentheses Detected (Missing Right Parenthesis)");
                throw new Error("Unbalanced Parentheses Detected - Missing A Right Parenthesis");
            case ScopeTokenValues.EndScope:
                logSvc.get(this).error("Invalid Search Request: Unbalanced Parentheses Detected (Missing Left Parenthesis");
                throw new Error("Unbalanced Parentheses Detected - Missing A Left Parenthesis");
            case ScopeTokenValues.ClosedScope:
                logSvc.get(this).debug("Building Search Request From Closed Scope (Pass-Through)");

                return childRequests[0]; //Unwrap the child request from the child request array

            default:
                throw new Error("Invalid Scope Token Scope Value");
        }

    }
}

export default ScopeToken;



//////////////////
// WEBPACK FOOTER
// ./src/models/parser-tokens/ScopeToken.js
// module id = Mxvq
// module chunks = 1